import { createBrowserHistory } from "history";
import { Instance } from "mobx-state-tree";
import { RouterModel, syncHistoryWithStore, SynchronizedHistory } from "mst-react-router";
import { Path } from "./utils";

export const RouterStore = RouterModel.named("RouterStore")
  .volatile(() => {
    let synchronizedHistory: SynchronizedHistory | undefined;
    return {
      synchronizedHistory
    };
  })
  .views((self) => ({
    get history(): SynchronizedHistory {
      return self.synchronizedHistory!;
    }
  }))
  .actions((self) => ({
    /**
     * @param roomId the roomId where we navigate to.
     * @param replace whether the url should be replaced (eg. incorrect/not-existing roomId has been detected).
     */
    goToRoom(roomId: string | undefined, replace = false) {
      const target = roomId ? Path.room(roomId) : Path.MAIN;
      if (replace) {
        self.replace(target);
      } else {
        self.push(target);
      }
    },

    afterCreate() {
      // synchronize history with the store.
      self.synchronizedHistory = syncHistoryWithStore(createBrowserHistory(), self);
    }
  }));

export type IRouterStore = Instance<typeof RouterStore>;
